import {Dispatch, SetStateAction, useState} from 'react';

import {domainIncidentAPI} from 'features/domain/api/domainIncidentAPI';
import IOrderBy from 'shared/model/IOrderBy';
import IPagination from 'shared/api/model/IPagination';
import {getPollingInterval} from 'shared/api/pollingHelper';

import IDomainIncident from './DomainIncident/IDomainIncident';

export interface IUseDomainMonitorIncidents {
    pagination: IPagination<IDomainIncident> | undefined,
    isLoading: boolean,
    isFetching: boolean,
    sort: IOrderBy | undefined,
    setSort: Dispatch<SetStateAction<IOrderBy | undefined>>,
    setPage: Dispatch<SetStateAction<number>>,
}

export const useDomainMonitorIncidents = (domainMonitorUuid: string): IUseDomainMonitorIncidents => {
    const [sort, setSort] = useState<IOrderBy>();
    const [page, setPage] = useState(1);

    const {data: pagination, isLoading, isFetching} = domainIncidentAPI.useGetDomainIncidentsAllQuery({
        page,
        sort,
        filters: [`domain_monitor.uuid=${domainMonitorUuid}`, 'ignore=false'],
    }, {
        pollingInterval: getPollingInterval(),
    });

    return {pagination, isLoading, isFetching, sort, setSort, setPage};
};

export default useDomainMonitorIncidents;
